import { cva, type VariantProps } from 'class-variance-authority'
import { Card } from '@repo/ui/components/ui/card'
import { surfaceRadii } from '@repo/ui/lib/design-tokens'
import { cn } from '@repo/ui/lib/utils'
import type { ComponentProps } from 'react'

const premiumPanelVariants = cva(
  cn('app-premium-panel', surfaceRadii.xl, 'border-border/70'),
  {
    variants: {
      tone: {
        default: '',
        destructive: 'border-destructive/30',
      },
    },
    defaultVariants: {
      tone: 'default',
    },
  }
)

interface PremiumPanelProps extends ComponentProps<typeof Card>, VariantProps<typeof premiumPanelVariants> {
  interactive?: boolean
}

export function PremiumPanel({
  className,
  interactive = false,
  tone,
  ...props
}: PremiumPanelProps) {
  return (
    <Card
      className={cn(
        premiumPanelVariants({ tone }),
        interactive && 'app-premium-panel-lift',
        className
      )}
      {...props}
    />
  )
}
